import React from 'react';


class Navbar extends React.Component {
    render() {
      return (
          <nav id="navbar">
            <ul>
                <li><a href="#welcome-section">About</a></li>
                <li><a href="#projects">My Creations</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>
          </nav>
         
        
      );
    }
  }
export default Navbar;
  